import { ReactNode, useState, useRef, useEffect } from "react";
import { prepareForTransition } from "utils/dom";

interface Props {
  /** The CSS class name that contains all of the styles for the element, including the CSS properties that keep
   * the element hidden. This should also include a transition CSS property. e.g.
   * 
   * opacity: 0; transition: opacity 1s;
   */
  className: string;
  /** The CSS class name that modifies the CSS properties of the className properties to show the element
   * opacity: 1;
  */
  revealClassName: string;
  children: ReactNode
  as?: keyof JSX.IntrinsicElements;
}
/** A component that makes transitioning CSS components easier. This relies on two CSS classes, one is always applied
 * and the other is only applied after the component has been rendered to cause the transition to run.
 */
const TransitionReveal = (props: Props) => {
  const [revealed, setRevealed] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (ref.current) {
      prepareForTransition(ref.current);
    }
    setRevealed(true);
  }, []);
  const Component: 'div' = (props.as as any) || 'div';
  return (
    <Component ref={ref} className={props.className + ' ' + (revealed ? props.revealClassName : '')}>
      {props.children}
    </Component>
  );
}

export default TransitionReveal;